<template>
  <BLayoutView
    :back-route="backRoute"
    :title="pageTitle"
    :skeleton="isLoadingAsyncData"
    hidden-footer
    class="ViewLKReportsView"
  >
    <template #title-after>
      <v-btn
        v-if="single && single.raw_file"
        :color="color"
        :href="single.raw_file.url"
        :download="filename"
        dense
        depressed
        dark
        v-text="'Скачать'"
      />
    </template>

    <component
      :is="component"
      v-if="component && data"
      :data="data"
      :skeleton="isLoadingAsyncData"
      style="margin-top: 20px;"
    />

    <div
      v-else-if="component === null && data"
      style="margin-top: 20px;"
      v-text="'Отчет в процессе разработки'"
    />

    <LKProgressCircular
      v-else
      overlay
      :size="50"
      style="align-items: start; padding-top: 30vh;"
    />
  </BLayoutView>
</template>

<script>
import variables from '@/assets/scss/exports.scss'
import { dateFormatter } from '@/helpers/dateFormatter'
import { LKReportMapper } from './store'
import { ReportCodes } from '@/typings/api/Report'
import {
  LK_REPORT_ROUTES as ROUTES,
  geReportFilename,
} from './utils'

import BLayoutView from '@/components/layouts/BLayoutView.vue'
import LKProgressCircular from '@/components/lk/LKProgressCircular.vue'


const LKReportsRoadmapCommon = () => import(
  /* webpackChunkName: "LKReportsRoadmapCommon" */
  './components/LKReportsRoadmapCommon.vue'
)

const LKReportsRoadmapBasicStatistics = () => import(
  /* webpackChunkName: "LKReportsRoadmapBasicStatistics" */
  './components/LKReportsRoadmapBasicStatistics.vue'
)

const LKReportsRoadmapDirectionEventStatistics = () => import(
  /* webpackChunkName: "LKReportsRoadmapDirectionEventStatistics" */
  './components/LKReportsRoadmapDirectionEventStatistics.vue'
)

export default {
  name: 'ViewLKReportsView',
  components: {
    BLayoutView,
    LKProgressCircular,
  },
  props: {
    id: {
      type: [String, Number],
      required: true,
    },
  },
  data: () => ({
    color: variables['webflow-color-blue'],
    isLoadingAsyncData: false,
    isLoading: false,
    data: null,
    backRoute: { name: ROUTES.LIST },
  }),
  computed: {
    ...LKReportMapper.mapState(['single']),

    pageTitle() {
      const { single } = this
      if (!single) return ''
      const date = dateFormatter(single.created_at)
      return `${single.title} (${date})`
    },
    filename() {
      return this.single && geReportFilename(this.single)
    },
    component() {
      const code = this.single?.code

      switch (code) {
        case ReportCodes.common:
        case ReportCodes.expert:
          return LKReportsRoadmapCommon

        case ReportCodes.basicStatistics:
          return LKReportsRoadmapBasicStatistics

        case ReportCodes.directionEventStatistics:
          return LKReportsRoadmapDirectionEventStatistics

        default:
          return null
      }
    },
  },
  methods: {
    ...LKReportMapper.mapActions(['getData', 'getOne']),

    asyncData() {
      const params = { id: this.id }
      this.onGetData(params)
    },
    async onGetData(params) {
      this.isLoading = true

      const promises = [
        this.getData(params),
        this.getOne(params),
      ]

      try {
        const results = await Promise.all(promises)
        this.data = results[0].data
      } catch (e) {
        this.$notice.errors(e)
      }
      this.isLoading = false
    },
  },
}
</script>

<style lang="scss">
.ViewLKReportsView {
  .container {
    padding: 0;
  }
}
</style>
